import React, { Component } from "react";
import settings from "../settings";
import Scrollbars from "react-custom-scrollbars";
import UploadModal from "./UploadModal";

const download = (data, onUploadClick, onDownloadClick, onHandleDelete) => {
  return (
    <div className={"download"} key={data.label}>
      <div className="downloadName">
        {data.label}
        {!data.uploaded && (
          <span className="text-danger text-sm"> Ontbreekt!</span>
        )}
      </div>
      <div className="downloadButtons">
        {data.uploaded ? (
          <>
            <button onClick={() => onHandleDelete(data)}>
              <i className="fas fa-trash text-danger"></i>
            </button>
            <button onClick={() => onUploadClick(data)}>
              <i className="fas fa-edit"></i>
            </button>
            <button onClick={() => onDownloadClick(data)}>
              <i className="fas fa-arrow-to-bottom"></i>
            </button>
          </>
        ) : (
          <button onClick={() => onUploadClick(data)}>
            <i className="fas fa-arrow-from-bottom"></i>
          </button>
        )}
      </div>
    </div>
  );
};

class Downloads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      data: [],
      showUploadModal: false,
      selectedFile: null,
      showNotification: true,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.setState({ isLoading: true });
    fetch(
      settings.server_url +
        "get_menu_uploads/" +
        window.sessionStorage.getItem("sid")
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.result) {
          const formattedData = response.data.map((item) => ({
            id: item.id,
            label: item.name,
            uploaded: item.uploaded,
            url: item.filename || "#",
          }));

          // Controleer of alle items uploaded === true zijn
          const allUploaded = formattedData.every(
            (item) => item.uploaded === true
          );

          this.setState({
            data: formattedData,
            isLoading: false,
            showNotification: !allUploaded, // false als alles uploaded is, true als er nog iets niet uploaded is
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ isLoading: false });
      });
  }

  handleUploadClick = (fileData) => {
    this.setState({
      showUploadModal: true,
      selectedFile: fileData,
    });
  };

  handleModalClose = () => {
    this.setState({
      showUploadModal: false,
      selectedFile: null,
    });
  };

  handleUpload = async (file) => {
    const formData = new FormData();
    formData.append("id", this.state.selectedFile.id);
    formData.append("file", file);

    try {
      const response = await fetch(
        settings.server_url +
          "upload_menu/" +
          window.sessionStorage.getItem("sid"),
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        this.loadData(); // Refresh the data
        this.handleModalClose();
      } else {
        console.error("Upload failed");
      }
    } catch (error) {
      console.error("Upload error:", error);
    }
  };

  handleDelete = async (fileData) => {
    if (window.confirm("Weet u zeker dat u dit bestand wilt verwijderen?")) {
      const formData = new FormData();
      formData.append("id", fileData.id);
      try {
        const response = await fetch(
          settings.server_url +
            "delete_menu/" +
            window.sessionStorage.getItem("sid"),
          {
            method: "POST",
            body: formData,
          }
        );

        if (response.ok) {
          this.loadData(); // Data opnieuw ophalen
        } else {
          console.error("Delete failed");
        }
      } catch (error) {
        console.error("Delete error:", error);
      }
    }
  };

  handleDownload = async (fileData) => {
    try {
      const response = await fetch(
        settings.server_url +
          "download_menu/" +
          window.sessionStorage.getItem("sid") +
          "?id=" +
          fileData.id,
        {
          method: "GET",
        }
      );

      if (response.ok) {
        // Get filename from response headers or use default
        const filename =
          response.headers.get("Content-Disposition")?.split("filename=")[1] ||
          fileData.label + ".pdf";

        // Create blob from response
        const blob = await response.blob();

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);

        // Append to body, click and remove
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

        // Clean up URL
        window.URL.revokeObjectURL(url);
      } else {
        console.error("Download failed");
      }
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  handleCloseNotification = () => {
    this.setState({ showNotification: false });
  };

  render() {
    return (
      <>
        <div className="gridItem">
          <div className="gridHeader">
            <div className="gridHeaderTitle">Mijn menukaarten</div>
          </div>
          {this.state.isLoading ? (
            <Scrollbars style={{ height: 272 }}>
              <div className="gridRows loading"></div>
            </Scrollbars>
          ) : this.state.data.length > 0 ? (
            <Scrollbars style={{ height: 272 }}>
              <div className="gridRows" key={this.state.data.label}>
                {this.state.data.map((row, index) =>
                  download(
                    row,
                    this.handleUploadClick,
                    this.handleDownload,
                    this.handleDelete
                  )
                )}
              </div>
            </Scrollbars>
          ) : (
            <Scrollbars style={{ height: 272 }}>
              <div className="gridRows"></div>
            </Scrollbars>
          )}
        </div>
        <UploadModal
          show={this.state.showUploadModal}
          handleClose={this.handleModalClose}
          handleUpload={this.handleUpload}
          fileName={this.state.selectedFile?.label || ""}
        />
        {this.state.showNotification && (
          <div
            className="notification-alert"
            style={{
              backgroundColor: "#ff4444",
              color: "white",
              padding: "15px 20px",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              display: "flex",
              alignItems: "center",
              margin: "10px",
              animation: "shake 0.5s ease-in-out",
            }}>
            <i
              className="fas fa-exclamation-triangle"
              style={{
                fontSize: "24px",
                marginRight: "15px",
                color: "#ffeb3b",
              }}></i>
            <label
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                margin: 0,
                flex: 1,
              }}>
              Let op: je hebt ontbrekende menukaarten
            </label>
            <i
              className="fas fa-times"
              onClick={this.handleCloseNotification}
              style={{
                cursor: "pointer",
                fontSize: "20px",
                padding: "5px",
                color: "#fff",
              }}
            />
          </div>
        )}
      </>
    );
  }
}

export default Downloads;
